export const constants = {
    exportMessages: {
        queuedSuccess:
            "Your export request could not be completed directly due to the size of the data. It has been submitted to the Report Queue and will be available for download once processing is complete.",
        largeDatasetQueued:
            "Your export contains a large number of rows, so it has been submitted to the Report Queue and will be available for download once processing is complete.",
        submissionFailed:
            "Your export request could not be submitted. Please try again or contact support if the problem persists.",
    },
    detailsMessages: {
        tooManyRows:
            "This report is taking too long to display because of the amount of data selected. Please select fewer records or reduce the date range and try again.",
    },
    headerProps:
    {
        feeCode: { title: 'Fee Code' },
        description: { title: 'Description' },
        total: { title: 'Total', type: 'money', showTotal: true, },
        feeId: { title: 'id', hidden: true }
    },
    detailSummaryHeaderProps: {
        payer: { title: 'Payer' },
        checkNumber: { title: 'Check #' },
        adjustmentAmount: { title: 'Adjustments', type: 'money' }
    },
    detailHeaderProps: {
        id: { title: 'id', hidden: true },
        payer: { title: 'Payer' },
        checkNumber: { title: 'Check Number' },
        ncpdp: { title: 'NCPDP' },
        checkDate: { title: 'Check Date', type: 'date' },
        checkAmount: { title: 'Check Amount', type: 'money' },
        rxNumber: { title: 'Rx #' },
        fillDate: { title: 'Fill Date', type: 'date' },
        transactionDate: { title: 'Transaction Date', type: 'date' },
        patientName: { title: 'Patient Name' },
        tyCode: { title: 'TY Code' },
        feeAdjustmentAmount: { title: 'Fee/Adjustment Amount', type: 'money', },
        reasonCode: { title: 'Reason Code' },
        reasonDescription: { title: 'Reason Description'}

    }

}